<!--<div class="theme-hide theme-gradient-bg theme-gradient-bg-catalog"></div>-->

@if (enrollmentService.enrollments$ | async; as enrollmentData) {
  @if (enrollmentService.enrollmentRounds$ | async; as rounds) {
    @if (enrollmentService.currentRounds$ | async; as currentRounds) {
      @if ((auth.hasFeature('WaitlistManagement') && (enrollmentService.conflictCount > 0))
        && (rounds.length && registration) && currentRounds.length) {
        <div class="alert alert-warning">
          <div class="row">
            <div class="col-md-10">
              <button aria-expanded="false" class="btn-waitlist-warning" (click)="isExpandWaitlistWarning = !isExpandWaitlistWarning">
                <span>
                  <i class="fa fa-fw" [ngClass]="isExpandWaitlistWarning ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  <strong>Warning: </strong>You have pending items in your Waitlist Management queue.  Please make sure you have made all your selections before the end of registration!
                </span>
              </button>
            </div>
            <div class="col-md-1">
              <button class="btn btn-sm btn-primary mt-2" type="button" (click)="dismissWaitlistAlert(currentRounds)"> Dismiss </button>
            </div>
          </div>
          @if (isExpandWaitlistWarning) {
            <div>
              You have elected to drop the following sections in the event of a waitlist promotion conflict:
              @if (enrollmentService.managedConflicts$ | async; as managedConflicts) {
                @if (!managedConflicts.length) {
                  <div class="mt-2"><strong>No conflicts have been managed yet.</strong></div>
                }
                @if (managedConflicts.length) {
                  <ul>
                    @for (enrollment of enrollmentData.enrollments; track enrollment) {
                      @for (conflicts of enrollment.Conflicts; track conflicts) {
                        @for (conflict of conflicts.Conflicts; track conflict) {
                          @if (conflict.IsDroppable) {
                            <li>
                              <strong>{{conflict.SectionTitle}}</strong> may drop for {{enrollment.Section.CourseCode}}-{{enrollment.Section.SectionNumber}} - {{enrollment.Section.Title}}
                            </li>
                          }
                        }
                      }
                    }
                  </ul>
                }
              }
            </div>
          }
        </div>
      }
    }
  }
}


<div class="card">
  @if (profileService.profile.version == 2) {
    @if (enrollmentService.enrollmentRounds$ | async; as rounds) {
      <div>
        @if (actionable$ | async; as actionableitems) {
          <!-- Alerts for DropAdd -->
          @if (rounds.length > 0 && registration) {
            <div class="accordion" id="roundInfo">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed text-bg-unc-green" type="button" data-bs-toggle="collapse" data-bs-target="#roundOpen" aria-expanded="false" aria-controls="roundOpen">
                    <strong>{{profileService.profile.components.labelLookup['DropAdd']}} is open. Click here for dates!</strong>
                  </button>
                </h2>
                <div id="roundOpen" class="accordion-collapse collapse" data-bs-parent="#roundInfo">
                  <div class="accordion-body text-bg-unc-green">
                    <strong>You are in {{rounds.length}} round(s).</strong>
                    @for (er of rounds; track er) {
                      <div class="enrollment-round">
                        <div class="pb-1">
                          @if ((er.AddStarts == er.DropStarts) && (er.AddEnds == er.DropEnds)) {
                            <div>
                              {{ er.Name }} - Add/Drop begins <strong>{{ er.AddStarts | localTimeZone: 'full-date' }}</strong> until <strong>{{ er.AddEnds | localTimeZone: 'full-date' }}</strong>
                            </div>
                          }
                          @if ((er.AddStarts != er.DropStarts) || (er.AddEnds != er.DropEnds)) {
                            <div>
                              {{er.Name}} - <strong>Add</strong> begins <strong> {{ er.AddStarts | localTimeZone: 'full-date' }}</strong> until <strong>{{ er.AddEnds | localTimeZone: 'full-date' }}.</strong>
                              <strong> Drop</strong> begins <strong>{{ er.DropStarts | localTimeZone: 'full-date' }}</strong> until <strong>{{ er.DropEnds | localTimeZone: 'full-date' }}</strong>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        }
        @if (enrollmentService.roundsActive$ | async; as roundsActive;) {
          @if (roundsActive.hasUpcoming && !registration) {
            <div class="accordion" id="roundUpcoming">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed text-bg-unc-green" type="button" data-bs-toggle="collapse" data-bs-target="#roundStartsSoon" aria-expanded="false" aria-controls="roundStartsSoon">
                    <strong>{{profileService.profile.components.labelLookup['DropAdd']}} round coming soon.</strong>
                  </button>
                </h2>
                <div id="roundStartsSoon" class="accordion-collapse collapse" data-bs-parent="#roundUpcoming">
                  <div class="accordion-body text-bg-unc-green">
                    Your next round starts on {{roundsActive.upcomingDate | localTimeZone: 'full-date' }}
                  </div>
                </div>
              </div>
            </div>
          }
        }
      </div>
    }
    <!-- Alerts for Bidding -->
    @if (this.profileService.componentStore['Bidding']) {
      @if (biddingService.auctionInfo$ | async; as auction) {
        <div>
          @if (auction.whatToShow != 1) {
            <div class="accordion" id="biddingInfo">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed text-bg-unc-green" type="button" data-bs-toggle="collapse" data-bs-target="#biddingOpen" aria-expanded="false" aria-controls="biddingOpen">
                    <strong><app-bidding-title [auction]="auction"></app-bidding-title></strong>
                  </button>
                </h2>
                <div id="biddingOpen" class="accordion-collapse collapse" data-bs-parent="#biddingInfo">
                  <div class="accordion-body text-bg-unc-green">
                    <app-bidding-details [auction]="auction"></app-bidding-details>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  }

  @if (profileService.hasStops) {
    <div class="alert alert-danger has-icon" role="alert">
      <i class="fas fa-exclamation me-2"></i>
      You have a financial hold that will prohibit enrollment activity. Visit <a class="link-dark" href="https://connectcarolina.unc.edu">ConnectCarolina</a> now to resolve it.
    </div>
  }
  <div class="card-header card-header-tabs">
    <!-- NAVIGATION TABS-->
    <div class="d-flex justify-content-between">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a [ngClass]="{'active': catalog.tabToShow == 'search'}" class="nav-link" href="#search" (click)="catalog.tabToShow='search'" data-bs-toggle="tab" role="tab" aria-controls="search" aria-selected="true">Search</a>
        </li>
        @if (catalog.favorites$ | async; as favorites) {
          <li class="nav-item">
            <a [ngClass]="{'active': catalog.tabToShow == 'favorites'}" class="nav-link" href="#favorites" data-bs-toggle="tab" role="tab" aria-controls="favorites" aria-selected="true" (click)="onShowFavorites(favorites)">
              <i class="fas fa-star" style="color:orange"></i> My Favorites ({{favorites.length}})
            </a>
          </li>
        }
        @if (actionable$ | async; as actionableitems) {
          @if (isAuctionActive) {
            <li class="nav-item">
              @if (biddingService.auctionBids$ | async; as auction) {
                <a (click)="catalog.tabToShow = 'bids'" [ngClass]="{'active': catalog.tabToShow == 'bids'}" class="nav-link" href="#bids" data-bs-toggle="tab" role="tab" aria-controls="bids" aria-selected="true">
                  <i class="far fa-dollar-sign" style="color:green"></i> My Bids ({{auction.Bids.length}})
                </a>
              }
            </li>
          }
        }
        @if (auth.hasFeature('WaitlistManagement')) {
          <li class="nav-item">
            <a [ngClass]="{'active': catalog.tabToShow == 'waitlistManagement'}" class="nav-link" href="#waitlistManagement" (click)="catalog.tabToShow='waitlistManagement'" data-bs-toggle="tab" role="tab" aria-controls="waitlistManagement" aria-selected="true">Waitlist Management @if (this.enrollmentService.conflictCount > 0) {
              ({{this.enrollmentService.conflictCount}})
            }</a>
          </li>
        }
        @if (auth.hasFeature('EnrollmentHistory')) {
          <li class="nav-item">
            <a [ngClass]="{'active': catalog.tabToShow == 'enrollmentHistory'}" class="nav-link" href="#enrollmentHistory" (click)="catalog.tabToShow='enrollmentHistory'" data-bs-toggle="tab" role="tab" aria-controls="enrollmentHistory" aria-selected="true">My History</a>
          </li>
        }
      </ul>
      <div class="float-end me-2"><a (click)="sidebarService.openHelp({name:'Catalog', title:'Catalog'})"><i class="widget-help fas fa-question-circle"></i></a></div>
    </div>
  </div>
  <div class="card-body">
    <div class="tab-content">
      <!-- SEARCH TAB-->
      <div class="tab-pane fade" [ngClass]="{'active show': catalog.tabToShow == 'search'}" id="search" role="tabpanel" aria-labelledby="search">
        @if (isCollapsed) {
          <div>@if (catalogResults$ | async; as results;) {
            <span>You searched for: <strong>"{{results.CatalogQuery}}"</strong></span>
          }</div>
        }
          <div id="collapseResults" [ngbCollapse]="isCollapsed">
              <!-- SEARCH FILTERS -->
              @if (utility.filterLookups$ | async; as lookups) {
              <form name="searchCatalog" #f="ngForm" (ngSubmit)="onSubmit(f)">
                  <!--  ACTIONABLE ITEMS-->
                  @if (actionable$ | async; as actionable) {
                  @if (registration || bidding) {
                  <div class="form-row mb-1">
                      <label class="switcher-control m-1 mb-0" aria-label="switcher-control">
                          <span class="sr-only">Is Actionable</span>
                          <input type="checkbox" class="switcher-input" [checked]="isActionable" (click)="toggleActionable()">
                          <span class="switcher-indicator pointer"></span>
                      </label>
                      <span class="action-label">
                          <input class="d-none" type="checkbox" name="rating5" id="ratings1" value="1" [checked]="isActionable" (click)="toggleActionable()">
                          <label for="ratings1" class="pointer">
                              Only show classes I can
                              @if (registration) {
                              add or drop
                              }
                              @if (registration && bidding) {
                              or
                              }
                              @if (bidding) {
                              bid on
                              }
                          </label>
                      </span>
                  </div>
                  }
                  }
                  <div class="row g-1">
                      <!-- ACADEMIC YEAR -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="academicYearSelect">Academic Year</label>
                          <select class="form-select form-select-sm" id="academicYearSelect" name="AcademicYear"
                                  [ngModel]="queryParams['AcademicYear'] ? queryParams['AcademicYear'] : profileService.settings.catalogYear"
                                  (ngModelChange)="updateSavedYear($event, lookups.defaults.academicyear);academicYear=$event;">
                              @for (ay of lookups.academicYears.Keywords; track ay) {
                              <option [value]="ay.Value">
                                  {{ay.Text}}
                              </option>
                              }
                          </select>
                      </div>
                      <!-- PROGRAM -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="program">Program</label>
                          <select class="form-select form-select-sm" id="program" name="Program" #program>
                              @if (registration || bidding) {
                              <option value="All" selected>All Programs</option>
                              }
                              @for (prog of lookups.programs.Keywords; track prog) {
                              <option [value]="prog.Value" [text]="prog.Text"
                                      [selected]="queryParams['Program']
                                        ? prog.Value == queryParams['Program']
                                        : (registration || bidding)
                                            ? prog.Value=='All'
                                            : catalog.defaultProgram == ''
                                                ? prog.Value==profileService.programFriendly
                                                : prog.Value==catalog.defaultProgram">
                                  {{prog.Text}}
                              </option>
                              }
                          </select>
                      </div>
                      <!-- COURSE TITLE -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="courseTitle">Course Title</label>
                          <input class="form-control form-control-sm" type="text" placeholder="Title" id="courseTitle" name="TitleLike" [ngModel]="queryParams['TitleLike'] ? queryParams['TitleLike'] : courseTitle" (ngModelChange)="queryParams['TitleLike'] ? queryParams['TitleLike'] : courseTitle = $event">
                      </div>
                      <!-- INSTRUCTOR NAME -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="instructorName">Instructor Name</label>
                          <input class="form-control form-control-sm" type="text" placeholder="Name" id="instructorName" name="InstructorNameLike" [ngModel]="queryParams['InstructorNameLike'] ? queryParams['InstructorNameLike'] : instructorName" (ngModelChange)="queryParams['InstructorNameLike'] ? queryParams['InstructorNameLike'] : instructorName = $event">
                      </div>
                      <!-- COURSE TYPE -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="typeSelect">Course Type</label>
                          <select class="form-select form-select-sm" id="classType" name="SectionType" [ngModel]="queryParams['SectionType'] ? queryParams['SectionType'] : classType" (ngModelChange)="queryParams['SectionType'] ? queryParams['SectionType'] : classType = $event">
                              @for (type of lookups.classTypes.Keywords; track type) {
                              <option [value]="type.Value">
                                  {{type.Text}}
                              </option>
                              }
                          </select>
                      </div>
                      <!-- COURSE NUMBER -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="courseNum">Course Number</label>
                          <input class="form-control form-control-sm" type="text" placeholder="000" id="courseNum" name="CourseNumberLike" [ngModel]="queryParams['CourseNumberLike'] ? queryParams['CourseNumberLike'] : classNum" (ngModelChange)="queryParams['CourseNumberLike'] ? queryParams['CourseNumberLike'] : classNum = $event">
                      </div>
                      <!-- COURSE DESCRIPTION -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="courseDesc">Course Description</label>
                          <input class="form-control form-control-sm" type="text" placeholder="Description" id="courseDesc" name="DescriptionLike" [ngModel]="queryParams['DescriptionLike'] ? queryParams['DescriptionLike'] : courseDesc" (ngModelChange)="queryParams['DescriptionLike'] ? queryParams['DescriptionLike'] : courseDesc = $event">
                      </div>
                      <!-- ACADEMIC AREA -->
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="areaSelect">Area</label>
                          <select class="form-select form-select-sm" id="academicArea" name="AcademicArea" [ngModel]="queryParams['AcademicArea'] ? queryParams['AcademicArea'] : academicArea" (ngModelChange)="queryParams['AcademicArea'] ? queryParams['AcademicArea'] : academicArea = $event">
                              @for (area of lookups.areas.Keywords; track area) {
                              <option [value]="area.Value">
                                  {{area.Text}}
                              </option>
                              }
                          </select>
                      </div>
                  </div>
                  <div class="row g-1">
                      <!-- TIME SLOT -->
                      <div class="col-auto">
                          <div class="col-form-label-sm">Class meeting times must include the following days</div>
                          <div class="border rounded ps-2 pt-1">
                              @for (day of lookups.days.Keywords; track day) {
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="checkbox" id="{{day.Text}}" [value]="day.Value" name="Day-{{day.Value}}" [(ngModel)]="day.checked">
                                  <label class="form-check-label" for="{{day.Text}}">{{day.Text}}</label>
                              </div>
                              }
                          </div>
                      </div>
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="startTime">Class Starts After</label>
                          <select class="form-select form-select-sm" id="startTime" name="startTime" [(ngModel)]="startTime">
                              <!--set startTime to 00:00 AM-->
                              <option selected value="00:00 AM">Any Time</option>
                              @for (number of lookups.times.Keywords; track number) {
                              <option>
                                  {{number}}
                              </option>
                              }
                          </select>
                      </div>
                      <div class="col-auto">
                          <label class="col-form-label-sm" for="endTime">Class Ends By</label>
                          <select class="form-select form-select-sm" id="endTime" name="endTime" [(ngModel)]="endTime">
                              <option selected value="11:59 PM">Any Time</option>
                              @for (number of lookups.times.Keywords; track number) {
                              <option>
                                  {{number}}
                              </option>
                              }
                          </select>
                      </div>
                      <!-- TERMS -->
                      @if (program.value!='All') {
                      <div class="col-auto">
                          <div class="col-form-label-sm">Terms</div>
                          <div class="border rounded ps-2 pt-1">
                              @for (term of lookups.terms.Keywords | termsFilter :
                              academicYear :
                              profileService.settings.catalogYear ? profileService.settings.catalogYear : lookups.defaults.academicyear :
                              program.value :
                              classType; track term.key) {
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="checkbox" id="Term-{{term.value.join('#')}}" [value]="term.key" name="Term-{{term.value.join('#')}}" [(ngModel)]="term.checked">
                                  <label class="form-check-label" for="Term-{{term.value.join('#')}}">{{term.key}}</label>
                              </div>
                              }
                              @if (((lookups.terms.Keywords | termsFilter : academicYear : lookups.defaults.academicyear :  program.value : classType ) | json) == '{}') {
                              <div>
                                  <label class="mb-0 col-form-label-sm pe-2">No terms available for this program</label>
                              </div>
                              }
                          </div>
                      </div>
                      }
                      <!-- UBP Mods -->
                      @if (program.value=='UBP') {
                      <div class="col-auto">
                          <div class="col-form-label-sm">Only show mod length classes</div>
                          <label class="switcher-control pointer">
                              <input type="checkbox" class="switcher-input" [checked]="isUbpMod" (click)="toggleUbpMod()">
                              <span class="switcher-indicator"></span>
                              <span class="switcher-label-on">YES</span>
                              <span class="switcher-label-off">NO</span>
                          </label>
                      </div>
                      }
                      <!-- MBA, EMBA-E, EMBA-EC and EMBA-W Virtual-->
                      @if (allowCrossEnrollment.includes(program.value)) {
                      <div class="col-auto">
                          <div class="col-form-label-sm">Seats</div>
                          <div class="border rounded ps-2 pt-1">
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="checkbox" id="ClassVirtual" value="virtual" name="ClassVirtual" [(ngModel)]="isVirtualClass">
                                  <label class="form-check-label" for="ClassVirtual">Offers Virtual Seats</label>
                              </div>
                          </div>
                      </div>
                      }
                      <!-- MBAO/MACO Blocks -->
                      @if (hasKeywords(lookups.blocks, program.value)) {
                      <div class="col-auto">
                          <div class="col-form-label-sm">Blocks</div>
                          <div class="border rounded ps-2 pt-1">
                              @for (block of lookups.blocks.Keywords; track block) {
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="checkbox" [id]="block.Value" [value]="block.Key" [name]="block.Value" [(ngModel)]="block.checked">
                                  <label class="form-check-label" for="{{block.Value}}">{{block.Key}}</label>
                              </div>
                              }
                          </div>
                      </div>
                      }
                  </div>
                  <button type="submit" class="btn btn-sm btn-primary mt-1 me-1 " [disabled]="isSearchRunning">
                      Search
                      @if (isSearchRunning) {
                      <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                      }
                      <span class="sr-only">Search</span>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-primary mt-1" [disabled]="isSearchRunning" (click)="resetSearchFields(f, lookups.defaults, registration || bidding )">
                      Reset
                      <span class="sr-only">Reset</span>
                  </button>
              </form>
              } @else {
              <div class="widget-action-loading text-center">
                  <div class="typing">
                      <span class="dot"></span>
                      <span class="dot"></span>
                      <span class="dot"></span>
                  </div>
              </div>
              }
          </div>
        <!-- Search Result Count -->
        <div class="d-flex justify-content-between pt-2" id="searchSummary" #searchSummary>
          @if (catalogSearch$ | async; as catalogResults) {
            @if (catalogResults.StartIndex) {
              <div class="ps-3 col-form-label-sm">
                Showing {{ catalogResults.StartIndex }}-{{ catalogResults.EndIndex }} of {{catalogResults.RecordCount}} courses
              </div>
              @if (catalogResults && catalogResults.TotalPages > 1) {
                <div>
                  <nav aria-label="Page navigation">
                    <ul class="pagination pagination-sm">
                      <li class="page-item me-1" [ngClass]="{'disabled': catalogResults.PageNumber == 1}">
                        <a class="page-link" (click)="onPaging(catalogResults.PageNumber-1, catalogResults.selectedColumn, catalogResults.searchFilters, catalogResults.isFavorite)" tabindex="-1">Previous</a>
                      </li>
                      <li class="page-item col-form-label-sm">
                        Page {{catalogResults.PageNumber}} of {{catalogResults.TotalPages}}
                      </li>
                      <li class="page-item ms-1" [ngClass]="{'disabled': catalogResults.PageNumber == catalogResults.TotalPages}">
                        <a class="page-link" (click)="onPaging(catalogResults.PageNumber+1, catalogResults.selectedColumn, catalogResults.searchFilters, catalogResults.isFavorite)">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              }
              <div class="me-2 ps-3 col-form-label-sm">
                <span class="me-1">
                  Sort by:
                  <a class="course-catalog-link" [ngClass]="{'bold-text': catalog.sortCoursesByName}" (click)="changeCourseSorting(true)">Name</a> |
                  <a class="course-catalog-link" [ngClass]="{'bold-text': !catalog.sortCoursesByName}" (click)="changeCourseSorting(false)">Number</a>
                </span>
                View:
                <a class="course-catalog-link" [ngClass]="{'bold-text': catalogResults.PageSize == 30}" (click)="onPageItemsClick(30)">30</a> |
                <a class="course-catalog-link me-1" [ngClass]="{'bold-text': catalogResults.PageSize == 60}" (click)="onPageItemsClick(60)">60</a>
                <a role="button" class="ps-1 mt-1 me-2" (click)="isCollapsed = !isCollapsed"
                  [attr.aria-expanded]="!isCollapsed" aria-controls="collapseResults" style="cursor:pointer">
                  @if (isCollapsed) {
                    <i class="fas fa-angle-double-down"></i>
                  }
                  @if (!isCollapsed) {
                    <i class="fas fa-angle-double-up"></i>
                  }
                </a>
              </div>
            }
          }
        </div>
        <hr />

        @if (isSearchRunning) {
          <div class="widget-action-loading text-center">
            <div class="typing">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        }

        @if (!isSearchRunning) {
          <ng-container [ngTemplateOutlet]="courselister" [ngTemplateOutletContext]="{items: catalogSearch$ | async}"></ng-container>
        }

      </div>
      <!-- FAVORITES TAB-->
      <div class="tab-pane fade" [ngClass]="{'active show': catalog.tabToShow == 'favorites'}" id="favorites" role="tabpanel" aria-labelledby="favorites">
        @if (isFavoritesLoading) {
          <div class="widget-action-loading text-center">
            <div class="typing">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        }
        @if (favoritesSearch$ | async; as favorites) {
          <ng-container [ngTemplateOutlet]="courselister" [ngTemplateOutletContext]="{ items:favorites }"></ng-container>
        }
      </div>
      <!-- BIDS TAB-->
      <div class="tab-pane fade" [ngClass]="{'active show': catalog.tabToShow == 'bids'}" id="bids" role="tabpanel" aria-labelledby="bids">
        @if (biddingService.auctionBids$ | async; as details) {
          <ng-container [ngTemplateOutlet]="auction" [ngTemplateOutletContext]="{ auction:details}"></ng-container>
        } @else {
          <div class="row">
            <div class="col-md-12">
              <span class="detail"> No results found</span><br />
            </div>
          </div>
        }
      </div>
      <!-- WAITLIST MANAGEMENT TAB -->
      <div class="tab-pane fade" [ngClass]="{'active show': catalog.tabToShow == 'waitlistManagement'}" id="waitlistManagement" role="tabpanel" aria-labelledby="waitlistManagement">
        @if (this.enrollmentService.enrollments$ | async; as enrollments) {
          <ng-container [ngTemplateOutlet]="waitlistManagement" [ngTemplateOutletContext]="{ items:enrollments }"></ng-container>
        } @else {
          <div class="widget-action-loading text-center">
            <div class="typing">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        }
      </div>
      <!-- ENROLLMENTS HISTORY TAB -->
      <div class="tab-pane fade" [ngClass]="{'active show': catalog.tabToShow == 'enrollmentHistory'}" id="enrollmentHistory" role="tabpanel" aria-labelledby="enrollmentHistory">
        @if (this.enrollmentService.enrollmentHistory$ | async; as history) {
          <ng-container [ngTemplateOutlet]="enrollmentHistoryLister" [ngTemplateOutletContext]="{ items:history }"></ng-container>
        } @else {
          <div class="widget-action-loading text-center">
            <div class="typing">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<ng-template #courselister let-items="items">
    @if (items) {
    @if (utility.filterLookups$ | async; as lookups) {
    @if (catalog.tabToShow != 'favorites') {
    <div class="alert text-center"
         [class.alert-primary]="items.TotalPages > 0"
         [class.alert-danger]="items.TotalPages == 0"
         [class.alert-warning]="items.AcademicYear < lookups.defaults.academicyear"
         [ngClass]="{'alert-danger': items.TotalPages == 0, 'alert-primary': items.TotalPages > 0}">
        @if (items.AcademicYear < lookups.defaults.academicyear) {
        <i class="fa-solid fa-circle-exclamation text-warning"></i>
        } Academic Year - {{items.AcademicYear}} / {{items.AcademicYear + 1}}
        @if (items.TotalPages == 0) {
        <span>&nbsp;- No courses found. Please try searching in a different year.</span>
        }
        @if (items.AcademicYear < lookups.defaults.academicyear) {
        <span>- This academic year is in the past.</span>
        }
    </div>
    }
    }
    }
    <!--  HIDE COLUMNS -->
    @if (items && items.TotalPages > 0) {
    <div class="d-flex justify-content-end mb-1">
        <div class="col-auto">
            <select class="form-select form-select-sm" id="columnSelector" aria-label="column selector" [(ngModel)]="items.selectedColumn">
                <option value="all" selected>All Columns</option>
                <option value="instructor">Instructors</option>
                <option value="meeting">Meeting Info</option>
                <option value="seats">Enrollments</option>
                <option value="desc">Course Description</option>
            </select>
        </div>
    </div>
    }

    <!-- SEARCH RESULTS -->
    @if (items) {
    <course-list [courses]="items.Courses" [people]="items.People" [column]="items.selectedColumn" [pagename]="catalog.tabToShow"></course-list>
    }

    <!-- PAGING -->
    @if (items && items.TotalPages > 1) {
    <div class="d-flex justify-content-center mt-1">
        <nav aria-label="Page navigation">
            <ul class="pagination pagination-sm">
                <li class="page-item me-1" [ngClass]="{'disabled': items.PageNumber == 1}">
                    <a class="page-link" (click)="onPaging(items.PageNumber-1, items.selectedColumn, items.searchFilters, items.isFavorite)" tabindex="-1">Previous</a>
                </li>
                <li class="page-item col-form-label-sm">
                    Page {{items.PageNumber}} of {{items.TotalPages}}
                </li>
                <li class="page-item ms-1" [ngClass]="{'disabled': items.PageNumber == items.TotalPages}">
                    <a class="page-link" (click)="onPaging(items.PageNumber+1, items.selectedColumn, items.searchFilters, items.isFavorite)">Next</a>
                </li>
                <li class="page-item ms-5">
                    <a class="page-link" (click)="goToTop()"><i class="fas fa-arrow-up"></i></a>
                </li>
            </ul>
        </nav>
    </div>
    }
</ng-template>

  <ng-template #enrollmentHistoryLister let-items="items">
    <div class="container-fluid">
      <div class="alert alert-info" role="alert">
        A 'System' action is either one taken by an administrator, or an automatic action in response to automated events like bidding or waitlist promotion. For example, "System Abandon Waitlist" usually means that your waitlist position was abandoned due to an unresolved conflict (because promoting from the waitlist would have created
        an enrollment conflict).
      </div>
      @if (items.length<=0) {
        <div class="row">
          <div class="col-md-12">
            <span class="detail"> No results found</span><br />
          </div>
        </div>
      }
      <div class="row enrollment-history-header">
        <div class="col-xl-2">When</div>
        <div class="col-xl-5">Section</div>
        <div class="col-xl-5">Action</div>
        <div class=""></div>
      </div>
      @for (item of items; track item) {
        <div class="row enrollment-history-item">
          <div class="col-xl-2"><span class="enrollment-history-item-header">When: </span>{{item.Date | date:'short'}}</div>
          <div class="col-xl-5"><span class="enrollment-history-item-header">Section: </span>{{item.Section}}</div>
          <div class="col-xl-5"><span class="enrollment-history-item-header">Action: </span>{{item.Action}}</div>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #auction let-auction="auction">
    @if (auction) {
      <div class="container-fluid">
        <div class="row ms-2">
          <div class="col-12">
            <div class="d-flex flex-row justify-content-between">
              @if (getCountDown$(auction.Timeline) | async; as countdown) {
                <div class="countdown-box">
                  <div class="float-start">
                    <a (click)="sidebarService.openHelp({name:'Bid Timeline', title:'Bid Timeline'})"><i class="bidding-help fas fa-question-circle me-1"></i></a>
                  </div>
                  <div class="countdown-header tile bg-success tile-circle tile-lg text-white">
                    {{countdown.shortTime}}
                  </div>
                  <div>
                    {{countdown.displayString | titlecase }} left to {{GetCurrentStatus(auction.Timeline) | lowercase}}.
                  </div>
                </div>
              }
              <ol class="progress-list w-100">
                @for (status of auction.Timeline; track status) {
                  <li [ngClass]="{'success': (status.Key < currentDate) && (!status.CurrentState), 'active': status.CurrentState}">
                    <button type="button">
                      <span class="progress-indicator"></span>
                      <span class="sr-only">{{status.Key}}</span>
                    </button>
                    <span class="progress-label" appHoverReplaceText [new]="status.Key | localTimeZone: 'date'" [original]="status.Value">{{status.Value}}</span>
                  </li>
                }
              </ol>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col me-4 ms-2">
            <div class="d-flex justify-content-center">
              <a (click)="sidebarService.openHelp({name:'Bid Points',title:'Bid Points'})"><i class="bidding-help fas fa-question-circle me-1"></i></a>
              <h4>{{auction.CurrentBidPoints}} points remaining</h4>
            </div>
            <div class="progress mb-3" style="height: 1.5rem;">
              <div class="progress-bar bg-success" style="font-size: 1.5rem" role="progressbar" [style.width.%]="(auction.CurrentBidPoints/auction.StartingBidPoints)*100" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </div>
        </div>
          @if((auction.currentStateIndex == 1) || (auction.currentStateIndex == 5)){
            <div class="alert alert-info">Bids are being processed.  Please come back later to view the results!</div>
          }
          @else{
            <div class="row">
                <div class="col">
                    @for (groupedBid of auction.Bids | groupByFilter: 'Status'; track groupedBid) {
                    <div class="card mb-3">
                        <header class="card-header border-0 p-2">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <a (click)="sidebarService.openHelp({name:groupedBid.key,title:groupedBid.key})" class="float-start"><i class="bidding-help fas fa-question-circle me-1"></i></a>
                                    <span (click)="groupedBid.hide = !groupedBid.hide" style="cursor:pointer">
                                        <span>{{groupedBid.key}}s ({{groupedBid.value.length}})</span>
                                        @if (groupedBid.hide) {
                                        <span>&nbsp;<i class="fas fa-angle-down"></i></span>
                                        }
                                        @if (!groupedBid.hide) {
                                        <span>&nbsp;<i class="fa fa-angle-up"></i></span>
                                        }
                                    </span>
                                </div>
                                <div>
                                    @if (groupedBid.key.indexOf('Current')>-1) {
                                    <button type="button" class="btn btn-primary btn-sm" [disabled]="catalog.updatedBids.length<=0 || isUpdateBidRunning" (click)="updateBids(auction)">
                                        Update {{catalog.updatedBids.length}} Bids
                                        @if (isUpdateBidRunning) {
                                        <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                        }
                                    </button>
                                    }
                                </div>
                            </div>
                        </header>
                        <div>
                            @if (!groupedBid.hide) {
                            <div class="card-body">
                                @if (groupedBid.key.indexOf('Won')>-1) {
                                <h4 class="card-title">These will be converted into enrollments soon.</h4>
                                }
                                @if (groupedBid.key.indexOf('Lost')>-1) {
                                <h4 class="card-title">You will be added to waitlists, if available, for any bids you have lost.</h4>
                                }
                                <div>
                                    @for (bid of groupedBid.value; track bid) {
                                    <div class="row waitlist-section row-highlight">
                                        <ng-container class="col-sm-12">
                                            @if (!bid.isDeleted) {
                                            <div class="col-md-1 col-lg-1 col-sm-1 waitlist-course">
                                                @if (bid.Conflicts) {
                                                <div class="fa-stack" placement="right" [ngbTooltip]="['Conflict']">
                                                    <i class="text-warning fas fa-circle fa-stack-2x"></i>
                                                    <strong class="fa-stack-1x fa-inverse">C</strong>
                                                </div>
                                                }
                                                @if (groupedBid.key.indexOf('Won')>-1 && !bid.Conflicts) {
                                                <div class="fa-stack" placement="right" [ngbTooltip]="['Won']">
                                                    <i class="fas fa-circle fa-stack-2x text-success"></i>
                                                    <i class="fas fa-check fa-stack-1x fa-inverse"></i>
                                                </div>
                                                }
                                                @if (groupedBid.key.indexOf('Current')>-1 && catalog.updatedBids.indexOf(bid.SectionId) >= 0) {
                                                <span class="fa-stack" placement="right" [ngbTooltip]="['Current']">
                                                    <i class="fal fa-circle text-success fa-stack-2x"></i>
                                                    <i class="far fa-dollar-sign fa-stack-1x text-success"></i>
                                                </span>
                                                }
                                                @if (groupedBid.key.indexOf('Current')>-1 && catalog.updatedBids.indexOf(bid.SectionId) < 0) {
                                                <span class="fa-stack" placement="right" [ngbTooltip]="['Current']">
                                                    <i class="fas fa-circle text-success fa-stack-2x"></i>
                                                    <i class="far fa-dollar-sign fa-stack-1x fa-inverse"></i>
                                                </span>
                                                }
                                                @if (groupedBid.key.indexOf('Lost')>-1) {
                                                <span class="fa-stack" placement="right" [ngbTooltip]="['Lost']">
                                                    <i class="fas fa-circle fa-stack-2x text-info"></i>
                                                    <span class="far fa-frown-open fa-stack-1x fa-inverse"></span>
                                                </span>
                                                }
                                            </div>
                                            }
                                            @if (!bid.isDeleted) {
                                            <div class="col-lg-5 col-md-5 col-sm-5 waitlist-course">
                                                <span class="course">
                                                    <span>{{ bid.ClassName }}</span>
                                                </span> ({{ bid.ClassNumber}})<br />
                                                <span>{{ bid.ClassStart | date: 'shortDate' }} - {{ bid.ClassEnd | date: 'shortDate' }}</span><br />
                                                <span>{{bid.NonStandardMeeting}}</span>@if (bid.NonStandardMeeting.length>0) {
                                                <br />
                                                }
                                                @for (meeting of bid.Meetings; track meeting) {
                                                <span>
                                                    {{ meeting.Days }} {{ meeting.Start | localTimeZone:'time'}} - {{ meeting.End | localTimeZone: 'time' }}<br />
                                                    {{ meeting.Building }} {{ meeting.Room }}
                                                </span>
                                                }
                                                @if (showAuctionActions(auction.Timeline)) {
                                                <div>
                                                    @if (groupedBid.key.indexOf('Won') > -1) {
                                                    <button type="button" class="btn btn-primary btn-sm" (click)="deleteBid(auction, bid, groupedBid, 'Cancel' )">
                                                        Cancel
                                                        @if (isDeleteBidRunning[bid.SectionId]) {
                                                        <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                                        }
                                                    </button>
                                                    }
                                                    @if (groupedBid.key.indexOf('Current') > -1) {
                                                    <button type="button" class="btn btn-danger btn-sm" (click)="deleteBid(auction, bid, groupedBid, 'Remove' )">
                                                        Remove
                                                        @if (isDeleteBidRunning[bid.SectionId]) {
                                                        <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                                        }
                                                    </button>
                                                    }
                                                    @if (groupedBid.key.indexOf('Lost') > -1) {
                                                    <button type="button" class="btn btn-danger btn-sm" (click)="deleteBid(auction, bid, groupedBid, 'Discard' )">
                                                        Discard
                                                        @if (isDeleteBidRunning[bid.SectionId]) {
                                                        <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                                        }
                                                    </button>
                                                    }
                                                    <br /><br />
                                                </div>
                                                }
                                            </div>
                                            }
                                            @if (!bid.isDeleted) {
                                            <div class="col-md-2 col-lg-2 col-sm-2 waitlist-course">
                                                @if (!showEditableBid(auction.Timeline)) {
                                                <span class="bid-display">{{bid.Points}} pts</span>
                                                }
                                                @if (showEditableBid(auction.Timeline) && groupedBid.key.indexOf('Current') > -1) {
                                                <input type="number" [(ngModel)]="bid.Points"
                                                       class="form-control form-control-sm mb-1 bid-input" (change)="bidUpdate(bid)" [ngClass]="{'input-highlight': catalog.updatedBids.indexOf(bid.SectionId) > -1 }" />
                                                }
                                                <h6>
                                                    <span [ngClass]="{'badge text-bg-warning': catalog.updatedBids.indexOf(bid.SectionId) > -1, 'd-none': catalog.updatedBids.indexOf(bid.SectionId) <= -1}">
                                                        Unsaved!
                                                    </span>
                                                </h6>
                                            </div>
                                            }
                                            @if (bid.Conflicts && !bid.isDeleted) {
                                            <div class="col-md-4 col-lg-4 px-4">
                                                <div class="alert alert-warning">
                                                    <p><strong>POTENTIAL CONFLICTS:</strong></p>
                                                    @for (conflict of bid.Conflicts; track conflict) {
                                                    <div class="col-md-12 col-lg-12 col-sm-12 waitlist-conflicts">
                                                        <div class="col-md-12 col-lg-12 col-sm-12">
                                                            <label for="{{conflict.SectionId}}">
                                                                Same {{conflict.Type}} as {{conflict.Title}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            }
                                        </ng-container>
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div class="row bid-calendar">
                <div class="col">
                    @if (catalog.tabToShow == 'bids') {
                    @if (biddingService.updateBiddingCalendar(biddingCalendar) | async; as calendar) {
                    <div class="card">
                        <header class="card-header border-0 p-2">
                            <div class="float-start">
                                <a (click)="sidebarService.openHelp({name:'Bid Calendar',title:'Bid Calendar'})"><i class="bidding-help fas fa-question-circle me-1"></i></a>
                            </div>
                            <div (click)="hideBidCalendar = !hideBidCalendar" style="cursor:pointer">
                                Calender view @if (hideBidCalendar) {
                                <span><i class="fas fa-angle-down"></i></span>
                                }
                                @if (!hideBidCalendar) {
                                <span><i class="fa fa-angle-up"></i></span>
                                }
                            </div>
                        </header>
                        @if (!hideBidCalendar) {
                        <div class="card-body">
                            <kfbs-full-calendar #calendar [defaultView]="biddingCalendar.defaultView"
                                                [mobileView]="biddingCalendar.mobileView"
                                                [defaultHeader]="biddingCalendar.defaultHeader"
                                                [mobileHeader]="biddingCalendar.mobileHeader"
                                                [mobileWindowSize]="biddingCalendar.mobileWindowSize"
                                                [customButtons]="biddingCalendar.customButtons"
                                                [calendarEventSource]="biddingCalendar.calendarEventSource"
                                                [editable]="false"
                                                [nowIndicator]="true"
                                                [slotEventOverlap]="false"
                                                [minTime]="'08:00'"
                                                [maxTime]="'21:00'"
                                                [defaultDate]="biddingCalendar.defaultDate">
                            </kfbs-full-calendar>
                        </div>
                        }
                    </div>
                    }
                    }
                </div>
            </div>
          }
      </div>
}
</ng-template>

<ng-template #waitlistManagement let-items="items">
  <div class="container-fluid">
    @if (items.enrollments) {
      <h3>Waitlist Management <button type="button" class="btn-explain" (click)="waitlistHelpExpand()">[@if (catalog.waitlistHelpExpand) {
        <span>Hide</span>
        }@if (!catalog.waitlistHelpExpand) {
        <span>Explain</span>
      }]</button></h3>
      @if (catalog.waitlistHelpExpand) {
        <div class="card card-body">
          <p>This tab shows any of your waitlisted sections that currently have conflicts. During Drop/Add those sections on waitlist may periodically be promoted to full enrollments.</p>
          <p>Being promoted from the waitlist MUST not create any conflicts on your schedule.  If you wish to keep the waitlisted section, check the box next to any corresponding conflicts.</p>
          <p>If you are promoted from the waitlist of a section, the conflicts you have checked will be abandoned or dropped as necessary. If there are any remaining conflicts you will not be awarded a seat in the class.</p>
        </div>
      }
      @if (this.enrollmentService.conflictCount == 0) {
        <div>No conflicts to manage</div>
      }
      @for (term of items.terms | conflictTermFilter :items.enrollments; track $index) {
        <span><br /><strong>{{term.AcademicYear}} {{term.Program}} {{term.FriendlyName}} Waitlist</strong><br /></span>
        @for (enrollment of items.enrollments | waitlistFilter; track $index) {
          @for (sectionTerm of enrollment.Section.Terms; track $index) {
            @if (term.Ids.indexOf(sectionTerm.TermId) > -1) {
              <conflict [enrollment]="enrollment" [instructors]="items.instructors"></conflict>
            }
          }
        }
      }
    }
  </div>
</ng-template>


